import { Box, Chip, FlexBox, Text } from '@dixa/lib-shared-habla';
import { MouseEventHandler } from 'react';

import { AIImproveWritingPromptName } from 'apis/ai';

import { Improvement } from '../editorCopilotDropdownImproveReply.constants';

import styles from './replyImprovementsContainer.module.scss';

type ReplyImprovementsContainerProps = {
  /** OnSelect callback for when a user selects a pill */
  onSelect: (value: string) => void;
  /** Array of pills to display */
  improvements: readonly Improvement<AIImproveWritingPromptName>[];
  /** Disable onSelect callback */
  disabled?: boolean;
};

export const ReplyImprovementsContainer = ({
  onSelect,
  improvements,
  disabled = false,
}: ReplyImprovementsContainerProps): JSX.Element => {
  return (
    <FlexBox flexDirection="row" padding="0 250 0" className={styles.root}>
      <Box flex="1 1 auto" className={styles.improvements}>
        {improvements.map(({ name, icon, value }) => {
          const onClick: MouseEventHandler<HTMLOrSVGElement> = (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (disabled) return;
            onSelect(value);
          };
          return (
            <Chip
              key={name}
              className={styles.improvement}
              onClick={onClick}
              disabled={disabled}
            >
              <img className={styles.improvementEmoji} src={icon} />
              <Text.Heading variant="heading-4">{name}</Text.Heading>
            </Chip>
          );
        })}
      </Box>
    </FlexBox>
  );
};
